<template>
  <div class="mb-4">
    <span class="text-gray-700">Tags</span>
    <div class="mt-1" v-for="tag in $store.state.settings.tags" :key="tag">
      <label class="inline-flex items-center">
        <input type="checkbox" class="form-checkbox" :value="tag" v-model="checked" />
        <span class="ml-2">{{ tag }}</span>
      </label>
    </div>
    <div class="text-gray-500 my-2" v-if="!$store.state.settings.tags.length">Nog geen tags</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      checked: []
    };
  },

  watch: {
    value: {
      handler() {
        this.checked = this.value.split(",").filter(v => v);
      },
      immediate: true
    },

    checked() {
      this.$emit("input", this.checked.join(","));
    }
  }
};
</script>
